"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const _service_1 = require("~service");
const KnowledgeBaseArticle = ({ contentId }) => {
    const { data, isLoading } = _service_1.knowledgeBaseArticleService.useGetKnowledgeBaseArticle({
        knowledgeBaseArticleId: contentId,
    });
    return isLoading ? ((0, jsx_runtime_1.jsx)(ui_1.Flex, { width: "100%", height: "100%", align: "center", justify: "center", children: (0, jsx_runtime_1.jsx)(ui_1.ActivityIndicator, { size: 50 }) })) : ((0, jsx_runtime_1.jsx)(ui_1.SidebarPageContent, { large: true, children: (0, jsx_runtime_1.jsx)(ui_1.RichText, { data: data }) }));
};
exports.default = KnowledgeBaseArticle;
